<template>
  <div class="my-3">
    <p class="mb-0 font-weight-bold">Order Notice ID</p>
    <input :value="statusDetails" class="form-control form-control-sm" type="text"
           @change="(event) => updateStatus(event.target.value)">
  </div>
</template>

<script>
import {addOrUpdateParameter} from "@/helpers/urlParamsHelper";

export default {
  name: "OrderNoticeId",

  computed: {
    statusDetails: function () {
      return this.$store.getters["search/getOrder_Notice_Id"];
    }
  },

  methods: {
    updateStatus(value) {
      this.$store.dispatch('search/updateOrder_Notice_Id', value);

      // Adds the new value as parameters to the URI
      const encodedParams = encodeURI(value);
      addOrUpdateParameter("order_notice", encodedParams);
    }
  }
}
</script>